<script lang="ts">
	import { Section, SectionHeader, type SectionTheme } from "#lib/web-ui/primitives/index.js";
	import { PodcastInquiryForm } from "#lib/web-ui/forms/index.js";
	import MicIcon from "@lucide/svelte/icons/mic";
	import { cloudinaryUrl } from "#lib/shared/cloudinary.js";

	let {
		theme = "muted" as SectionTheme,
		class: className
	}: {
		theme?: SectionTheme;
		class?: string;
	} = $props();
</script>

<Section {theme} class={className}>
	<div class="grid grid-cols-1 gap-y-12 lg:grid-cols-2 lg:gap-x-12">
		<div class="flex flex-col">
			<SectionHeader
				label="Podcast Booking"
				title="Have Brian on Your Podcast"
				subtitle="Brian Ferguson is available for podcast appearances to discuss real estate investing, syndication, market analysis, and building wealth through commercial real estate."
				align="left"
				class="mb-8"
			/>

			<div class="bg-card flex grow flex-col gap-6 rounded border p-6">
				<div class="flex gap-6">
					<img
						src={cloudinaryUrl("fergmarcapital-com/brian-ferguson-photo", {
							width: 200,
							height: 200,
							crop: "fill"
						})}
						alt="Brian H. Ferguson"
						class="h-[100px] w-[100px] shrink-0 rounded-full object-cover"
						width="100"
						height="100"
					/>
					<div class="flex flex-col justify-center">
						<h4 class="text-foreground text-xl font-semibold">Brian H. Ferguson</h4>
						<p class="text-primary font-medium">Founder & Managing Partner</p>
					</div>
				</div>

				<div class="space-y-3">
					<h4 class="text-foreground text-sm font-semibold">Topics Brian covers:</h4>
					<ul class="text-muted-foreground space-y-2 text-sm">
						<li class="flex items-start gap-2">
							<MicIcon class="text-primary mt-0.5 h-3.5 w-3.5 shrink-0" />
							Real estate syndication and passive investing
						</li>
						<li class="flex items-start gap-2">
							<MicIcon class="text-primary mt-0.5 h-3.5 w-3.5 shrink-0" />
							Value-add multifamily and commercial strategies
						</li>
						<li class="flex items-start gap-2">
							<MicIcon class="text-primary mt-0.5 h-3.5 w-3.5 shrink-0" />
							Secondary market investing and deal sourcing
						</li>
						<li class="flex items-start gap-2">
							<MicIcon class="text-primary mt-0.5 h-3.5 w-3.5 shrink-0" />
							Building a vertically integrated real estate firm
						</li>
						<li class="flex items-start gap-2">
							<MicIcon class="text-primary mt-0.5 h-3.5 w-3.5 shrink-0" />
							Entrepreneurship and wealth building
						</li>
					</ul>
				</div>
			</div>
		</div>

		<div class="flex flex-col">
			<div class="bg-card flex flex-col rounded border p-8 shadow-sm">
				<h3 class="text-foreground text-xl font-semibold">Schedule a Podcast Appearance</h3>
				<p class="text-muted-foreground mt-2 mb-6">
					Fill out the form below and our team will get back to you to coordinate
					scheduling.
				</p>
				<PodcastInquiryForm />
			</div>
		</div>
	</div>
</Section>
